import { PictureOutlined, QuestionCircleFilled } from "@ant-design/icons"
import { InputNumber, Spin, Tooltip } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useState } from "react"
import { MarketingSettingData, MediaData } from "~/types/types"
import { configs } from "../../../configs"
import { t } from "../../../languages/i18n"
import { addMedia } from "../../media/services/apiServices"

interface MarketingInforProp {
  popupInformation: MarketingSettingData
  setPopupInformation: React.Dispatch<React.SetStateAction<MarketingSettingData>>
}

const MarketingInformation = ({ popupInformation, setPopupInformation }: MarketingInforProp) => {
  const [loading, setLoading] = useState(false)
  const handleChange = (field: string, value: any) => {
    setPopupInformation(prevData => ({
      ...prevData,
      [field]: value,
    }))
  }

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0]
      setLoading(true)

      const formData = new FormData()
      formData.append("files", file)

      try {
        const response: MediaData[] = await addMedia(formData)
        if (response && response.length > 0) {
          const newImageUrls = response.map(item => `${configs.API_URL}${item.url}`)
          setPopupInformation(prevData => ({
            ...prevData,
            image: [...(prevData.image || []), ...newImageUrls],
          }))
        }
      } catch (error) {
        console.error("Image upload failed", error)
      } finally {
        setLoading(false)
      }
    }
  }
  const handleRemoveImage = (indexToRemove: number) => {
    setPopupInformation(prevData => ({
      ...prevData,
      image: prevData.image.filter((_, index) => index !== indexToRemove),
    }))
  }
  return (
    <div className="flex flex-col w-full">
      <h2 className="text-base font-semibold">{t("Marketing Information")}</h2>
      <div className="w-full flex flex-row gap-4 mt-4">
        <div className="flex flex-col gap-2 w-2/5">
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <h2>{t("Set time for display popup information")}</h2>
              <Tooltip title={t("Time to show information on the website when you first log in")}>
                <QuestionCircleFilled style={{ fontSize: 18 }} />
              </Tooltip>
            </div>
            <div className="flex flex-row w-full justify-between gap-2">
              <div className="flex flex-row gap-2 items-center">
                <p className="min-w-9">{t("Second")}:</p>
                <InputNumber
                  min={0}
                  value={Number(popupInformation.displayTime)}
                  onChange={value => handleChange("displayTime", value)}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-6">
            <div className="flex flex-row items-center gap-2">
              <h2>{t("Set time for hidden popup information")}</h2>
              <Tooltip title={t("Set time for hidden popup information")}>
                <QuestionCircleFilled style={{ fontSize: 18 }} />
              </Tooltip>
            </div>
            <div className="flex flex-row w-1/3 gap-2 items-center">
              <p className="min-w-9">{t("Day")}:</p>
              <InputNumber
                min={0}
                value={popupInformation.hiddenTime ? Number(popupInformation.hiddenTime) / 3600 : 0}
                onChange={value => handleChange("hiddenTime", value ? value * 3600 : 0)}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 w-3/5">
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <h2>{t("Content")}</h2>
              <Tooltip title={t("Content on the first notice of login")}>
                <QuestionCircleFilled style={{ fontSize: 18 }} />
              </Tooltip>
            </div>
            <TextArea value={popupInformation.content} onChange={e => handleChange("content", e.target.value)} />
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <h2>{t("Images")}</h2>
              <Tooltip title={t("Pictures on the first notice of login")}>
                <QuestionCircleFilled style={{ fontSize: 18 }} />
              </Tooltip>
            </div>
            <div className="flex flex-row items-center gap-2">
              <button
                className=" h-20 w-20 p-4 border bg-gray-100 hover:opacity-75 duration-200 rounded-lg flex flex-col items-center justify-center gap-2"
                onClick={() => document.getElementById("uploadImage")?.click()}
              >
                <PictureOutlined />
                <p className="text-nowrap">{t("Add image")}</p>
                <input type="file" className="hidden" id="uploadImage" onChange={handleImageUpload} />
              </button>
              {popupInformation.image?.length > 0 && (
                <div className="flex flex-row">
                  {popupInformation.image.map((url, index) => (
                    <div className="relative" key={index}>
                      <img
                        src={url}
                        alt={`Uploaded Preview ${index + 1}`}
                        className="w-20 h-20 object-cover rounded-lg mr-2"
                      />
                      <button
                        className="absolute -top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center hover:opacity-75 duration-200"
                        onClick={() => handleRemoveImage(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
              {loading && <Spin size="small" />}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarketingInformation
